import { render, staticRenderFns } from "./ModalUpdateInformation.vue?vue&type=template&id=317ba80e&"
import script from "./ModalUpdateInformation.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateInformation.vue?vue&type=script&lang=js&"
import style0 from "./ModalUpdateInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports